export class TrainingPlanning {
    constructor(
        public id: number,
        public startDate: Date,
        public agencyId: number,
        public agencyName: String,
        public trainerId: number,
        public trainerLastName: String,
        public trainerFirstName: String,
        public trainingTitle: String,
        public trainingId: number
    ) {}
}



// WEBPACK FOOTER //
// ./src/app/_services/training/planning/training-planning.model.ts